import { feBusinessStripeFoldToggle, fePolicyFocusNote, fePolicyFoldOpen, fePolicyFoldToggle, feSetStylistId, feStripeFoldToggle, feTipsFoldToggle, feVoucherPanelToggle } from 'actions/ui.actions';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

const reduceStripeFoldoutToggle = (state) => ({
  ...state,
  stripeFoldoutOpen: !state.stripeFoldoutOpen,
});

const reducePolicyFoldoutOpen = (state) => ({
  ...state,
  policyFoldoutOpen: true,
});

const reduceBusinessStripeFoldoutToggle = (state) => ({
  ...state,
  stripeBusinessFoldoutOpen: !state.stripeBusinessFoldoutOpen,
});

const reduceTipsFoldoutToggle = (state) => ({
  ...state,
  tipsFoldoutOpen: !state.tipsFoldoutOpen,
});

const reducePolicyFoldoutToggle = (state) => ({
  ...state,
  policyFoldoutOpen: !state.policyFoldoutOpen,
});

const reducePolicyFocusNote = (state) => ({
  ...state,
  policyFocusNote: true, // focus event
});

const reduceVoucherPanelToggle = (state) => ({
  ...state,
  voucherPanelOpen: !state.voucherPanelOpen,
});

const reduceClearSelectedStylist = (state, action) => ({
  ...state,
  stylistId: action?.payload, // null on close
});

const MAP = Object.freeze({
  [feStripeFoldToggle.AT.name]: reduceStripeFoldoutToggle,
  [feBusinessStripeFoldToggle.AT.name]: reduceBusinessStripeFoldoutToggle,
  [feTipsFoldToggle.AT.name]: reduceTipsFoldoutToggle,
  [feSetStylistId.AT.name]: reduceClearSelectedStylist,
  [fePolicyFocusNote.AT.name]: reducePolicyFocusNote,
  [fePolicyFoldToggle.AT.name]: reducePolicyFoldoutToggle,
  [fePolicyFoldOpen.AT.name]: reducePolicyFoldoutOpen,
  [feVoucherPanelToggle.AT.name]: reduceVoucherPanelToggle,
  // add more or reset state
});

const initialState = () => ({
  stripeFoldoutOpen: false,
  stripeBusinessFoldoutOpen: false,
  tipsFoldoutOpen: false,
  policyFoldoutOpen: false,
  policyFocusNote: false,
  voucherPanelOpen: false,
  stylistId: null,
});

const uiReducer = (state, action) => (MAP[action?.type] ?? alwaysSame)(state ?? initialState(), action ?? {});

export default uiReducer;
